// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1lSjh","col":"CardReaderDesc_col__3hn5L","label":"CardReaderDesc_label__Ql2_F"};